import { ThemeIcon, NavLink } from '@mantine/core';
import { IconMoneybag } from '@tabler/icons';
import { AppRoutePaths } from '../../../utils/enums';

interface OrdersLinkProps {
  navigate(to: string): void;
  themeColor: 'dark' | 'light';
}

export function FinancialLink({ navigate, themeColor }: OrdersLinkProps) {
  return (
    <NavLink
      styles={{
        label: {
          color: themeColor === 'light' ? '#373A40' : '#FBFBFB',
        },
      }}
      label="Financeiro"
      fw="bold"
      color=""
      icon={
        <ThemeIcon color="green" variant="light">
          <IconMoneybag size={16} />
        </ThemeIcon>
      }
      childrenOffset={28}
    >
      <NavLink
        label="Faturamento"
        onClick={() => navigate(AppRoutePaths.FINANCIAL_INVOICE)}
      />
      <NavLink
        label="Pagamento"
        onClick={() => navigate(AppRoutePaths.FINANCIAL_PAYMENT)}
      />
      <NavLink
        label="Controle de NF"
        onClick={() => navigate(AppRoutePaths.FINANCIAL_NF_CONTROL)}
      />
    </NavLink>
  );
}
